// PublicRoute.jsx
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

export const PublicRoute = ({ children }) => {
    const location = useLocation();
    const { isAuthenticated } = useAuth();

    if (isAuthenticated) {
        // workspaces로 리다이렉트
        window.location.href = `${process.env.REACT_APP_APP_DOMAIN}/workspaces`;
        return null;
    }

    return children;
};